import React from "react";
import cx from "classnames";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";

type TableCardProps = {
  head: React.ReactNode[];
  body: React.ReactNode[][];
  headerTitle?: React.ReactNode;
  classNames?: string;
};

export const TableCard = ({
  head,
  body,
  headerTitle,
  classNames,
}: TableCardProps) => (
  <table className={cx(s.table, classNames)}>
    <thead>
      <tr>
        {headerTitle ?? <th />}
        {head.map((col, i) => (
          <th key={i}>{col}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {body.map((row, i) => (
        <tr key={i}>
          {row.map((col, j) => (
            <React.Fragment key={j}>
              {j === 0 ? <th>{col}</th> : <td>{col}</td>}
            </React.Fragment>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);
